import React, {useCallback, useEffect, useState} from 'react';
import {Button, Modal} from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import {useTimeRange} from '../../context/StatisticsContext';

const CustomRangeModal = ({onShow}) => {
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState({start: undefined, end: undefined});

  const {updateAbsoluteRange} = useTimeRange();

  const handleClose = useCallback(() => setShow(false), []);
  const handleShow = useCallback(() => setShow(true), []);

  useEffect(() => {
    onShow(handleShow);
  }, [onShow, handleShow]);

  const generateReport = async () => {
    setLoading(true);

    const start = new Date(selectedPeriod.start).toISOString();
    const end = new Date(selectedPeriod.end).toISOString();

    updateAbsoluteRange(start, end);
    handleClose();
    setLoading(false);
  };

  const startMinDate = () => {
    if (selectedPeriod.end !== undefined) {
      return new Date(new Date(selectedPeriod.end).getTime() - (30 * 24 * 60 * 60 * 1000));
    }
    return new Date(new Date().getFullYear() - 1, 0, 1);
  };

  const startMaxDate = () => {
    if (selectedPeriod.end !== undefined) {
      return new Date(selectedPeriod.end);
    }
    return new Date();
  };

  const endMaxDate = () => {
    if (selectedPeriod.start !== undefined) {
      const thirtyDaysLater = new Date(new Date(selectedPeriod.start).getTime() + (30 * 24 * 60 * 60 * 1000));
      if (thirtyDaysLater > new Date()) {
        return new Date();
      }
      return thirtyDaysLater;
    }
    return new Date();
  };

  return (
    <>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Select Custom Date Range</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label">Start Date</label>
            <DatePicker
              selected={selectedPeriod.start}
              onChange={(date) => setSelectedPeriod({...selectedPeriod, start: date})}
              minDate={startMinDate()}
              maxDate={startMaxDate()}
              showTimeSelect
              timeFormat="HH:mm"
              dateFormat="dd.MM.yyyy HH:mm"
              className="form-control"
            />
          </div>
          <div className="mb-3">
            <label className="form-label">End Date</label>
            <DatePicker
              selected={selectedPeriod.end}
              onChange={(date) => setSelectedPeriod({...selectedPeriod, end: date})}
              minDate={selectedPeriod.start}
              maxDate={endMaxDate()}
              showTimeSelect
              timeFormat="HH:mm"
              dateFormat="dd.MM.yyyy HH:mm"
              className="form-control"
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={generateReport}
            disabled={loading || !selectedPeriod.start || !selectedPeriod.end}
          >
            {loading ? 'Loading...' : 'Apply'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CustomRangeModal;
